import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";

const ImageUpload = ({
                         name,
                         existingImage = "",
                         onFileChange = () => { },
                     }) => {
    const [previewImage, setPreviewImage] = useState(existingImage);
    const [localFile, setLocalFile] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileUrl = URL.createObjectURL(file);
            setPreviewImage(fileUrl); // Blob URL
            setLocalFile(file);
            onFileChange(file);
        }
    };

    const removeImage = () => {
        setPreviewImage("");
        setLocalFile(null);
        onFileChange(null);
    };

    useEffect(() => {
        if (existingImage) {
            setPreviewImage(existingImage);
        } else if (!localFile) {
            setPreviewImage("");
        }
    }, [existingImage, localFile]);

    useEffect(() => {
        return () => {
            if (previewImage && previewImage.startsWith('blob:')) {
                URL.revokeObjectURL(previewImage);
            }
        };
    }, [previewImage]);

    return (
        <div className="mt-3 mb-8">
            {!previewImage ? (
                <label className="relative flex flex-col items-center justify-center w-1/2 h-60 border-2 border-dashed border-gray-400 rounded-md cursor-pointer hover:border-blue-500 transition-all">
                    <div className="flex flex-col items-center justify-center text-gray-500">
                        <FontAwesomeIcon icon={faPlus} className="text-2xl mb-2" />
                        <span className="text-sm">Upload Image</span>
                    </div>
                    <input
                        type="file"
                        name={name}
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        accept="image/*"
                        onChange={handleFileChange}
                    />
                </label>
            ) : (
                <div className="relative w-1/2 h-60 border rounded-md overflow-hidden">
                    <img
                        src={previewImage}
                        alt="Uploaded preview"
                        className="w-full h-full object-cover"
                    />
                    <button
                        className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-2 text-xs z-10"
                        onClick={removeImage}
                        type="button"
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
            )}
        </div>
    );
};

export default ImageUpload;
